import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import Main from '../Main';
import rolesImg from '../../assets/images/Settings/rolesImg.svg'
import department from '../../assets/images/Settings/department.svg'
import designation from '../../assets/images/Settings/designation.svg'
import customerClassification from '../../assets/images/Settings/customerClassification.svg'
import relationshipType from '../../assets/images/Settings/relationshipType.svg'
import issueType from '../../assets/images/Settings/issueType.svg'
import menubar from '../../assets/images/Settings/menubar.svg'
import holiday from '../../assets/images/Settings/holiday.svg'
import customField from '../../assets/images/Settings/customField.svg'
import wqRules from '../../assets/images/Settings/wqRules.svg'
import functionalApproval from '../../assets/images/Settings/functionalApproval.svg'
import financialApproval from '../../assets/images/Settings/financialApproval.svg'
import complaintsApproval from '../../assets/images/Settings/complaintsApproval.svg'
import escalationApproval from '../../assets/images/Settings/escalationApproval.svg'
import leaveApproval from '../../assets/images/Settings/leaveApproval.svg'
import slaCategories from '../../assets/images/Settings/slaCategories.svg'
import organizationChart from '../../assets/images/Settings/organizationChart.svg'
import systemNumbering from '../../assets/images/Settings/systemNumbering.svg'
import '../../assets/css/Settings.scss'
import { Link, useNavigate } from 'react-router-dom';
import Download from '../MainSection/Download/Download';

const items = [
    { icon: <img src={rolesImg} alt="" />, title: 'Roles', content: 'Manage user roles and permissions to control access within the system.', path: '/settings/roles' },
    { icon: <img src={department} alt="" />, title: 'Department', content: 'Organize users into departments to streamline workflows and team management.', path: '/settings/department' },
    { icon: <img src={designation} alt="" />, title: 'Job Title / Designation', content: 'Define and manage employee job titles or designations to clarify roles.', path: '/settings/designation' },
    { icon: <img src={customerClassification} alt="" />, title: 'Customer Classification', content: 'Categorize customers based on criteria like industry or size to tailor services.', path: '/settings/customerClassification' },
    // { icon: <img src={relationshipType} alt="" />, title: 'Relationship Type', content: 'ContentContentContentContent', path: '/settings/relationshipType' },
    { icon: <img src={issueType} alt="" />, title: 'Issue Type', content: ' Define different types of issues for easier tracking and resolution in support workflows.', path: '/settings/issueType' },
    { icon: <img src={menubar} alt="" />, title: 'Menu Bar Enable / Disable', content: 'Control visibility of menu items based on user roles and permissions.', path: '/settings/moduleMangement' },
    { icon: <img src={holiday} alt="" />, title: 'Leave Policy & Holiday', content: 'Set up leave rules and public holidays for employee time-off management.', path: '/settings/holidays' },
    { icon: <img src={customField} alt="" />, title: 'Custom Field', content: 'Create custom data fields to capture specific information for various records.', path: '/settings/customFields' },
    { icon: <img src={wqRules} alt="" />, title: 'WQ Rules', content: 'Set rules for managing and assigning tasks within work queues automatically.', path: '/settings/wqRules' },
    { icon: <img src={functionalApproval} alt="" />, title: 'Functional Approval', content: 'Define approval workflows for functional tasks or processes in the organization.', path: '/settings/functionalApproval' },
    { icon: <img src={financialApproval} alt="" />, title: 'Financial Approval', content: 'Configure approval processes for financial transactions and budgets.', path: '/settings/financialApproval' },
    { icon: <img src={complaintsApproval} alt="" />, title: 'Complaints Approval', content: 'Manage workflows for reviewing and resolving customer complaints.', path: '/settings/complaintsApproval' },
    { icon: <img src={escalationApproval} alt="" />, title: 'Escalation Approval', content: 'Set up escalation rules for urgent or unresolved issues.', path: '/settings/escalationApproval' },
    { icon: <img src={leaveApproval} alt="" />, title: 'Leave Approval', content: 'Manage approval workflows for employee leave requests.', path: '/settings/leaveApproval' },
    { icon: <img src={slaCategories} alt="" />, title: 'SLA Checklist', content: 'Define response and resolution time targets for different service categories.', path: '/settings/slaCategories' },
    { icon: <img src={organizationChart} alt="" />, title: 'Organization Chart', content: 'Visualize company structure, teams, and reporting hierarchies.', path: '/settings/organizationChart' },
    { icon: <img src={systemNumbering} alt="" />, title: 'System Numbering', content: 'Configure automatic numbering for records like tickets or orders.', path: '/settings/systemNumbering' },
    { icon: <img src={systemNumbering} alt="" />, title: 'REST Data Sources', content: 'Configure automatic numbering for records like tickets or orders.', path: '/settings/rest-data-sources' },
    { icon: <img src={systemNumbering} alt="" />, title: 'Dashboards', content: 'Configure automatic numbering for records like tickets or orders.', path: '/settings/dynamic-dashboards' },
    // { icon: <img src={systemNumbering} alt="" />, title: 'Modules', content: 'Enable or disable core system modules for different functions.', path: '/settings/modules' },
    // { icon: <img src={systemNumbering} alt="" />, title: 'Sub Modules', content: 'Manage smaller functional areas under larger modules for better organization.', path: '/settings/sub-modules' },
];

const Settings = () => {

    // Retrieve sign-in details from sessionStorage
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [];
    const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID')) || null;


    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    // Filter items based on signInType
    // const filteredItems = signInType === 'SuperAdmin'
    //     ? items
    //     : signInType === 'ClientAdmin'
    //         ? items.filter(item => ['Roles', 'Department', 'Job Title / Designation', 'Functional Approval', 'Financial Approval', 'Complaints Approval', 'Escalation Approval', 'Custom Field', 'WQ Rules', 'SLA Checklist', 'System Numbering', 'REST Data Sources', 'Organization Chart'].includes(item.title))
    //         : [];

    let filteredItems = [];

    if (signInType === 'SuperAdmin') {
        filteredItems = items;
    } else if (signInType === 'ClientAdmin') {
        filteredItems = items.filter(item =>
            ['Roles', 'Department', 'Job Title / Designation', 'Functional Approval', 'Financial Approval', 'Complaints Approval', 'Escalation Approval', 'Custom Field', 'WQ Rules', 'SLA Checklist', 'System Numbering', 'REST Data Sources', 'Organization Chart']
                .includes(item.title)
        );

        // ✅ Add Menu Bar if PreviousCompanyID exists
        if (PreviousCompanyID) {
            const additionalItems = ['Menu Bar Enable / Disable', 'Dashboards'];
            additionalItems.forEach(title => {
                const menuItem = items.find(item => item.title === title);
                if (menuItem && !filteredItems.find(i => i.title === title)) {
                    filteredItems.push(menuItem);
                }
            });
        }
    }

    return (
        <Main>
            <div className='components-download-container'>
                <Download
                    showBackButton={true}
                    moduleName="Settings"
                    onBackClick={handleBack}
                />
            </div>
            <Grid container spacing={3} style={{ padding: '20px' }}>
                {filteredItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={index} style={{ paddingLeft: '25px' }}>
                        <Link to={item.path} style={{ textDecoration: 'none' }}>
                            <Card className='settings-card-container'>
                                <div className='settings-card-image'>
                                    {item.icon}
                                </div>
                                <CardContent className='settings-text-container'>
                                    <Typography variant="h6">{item.title}</Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {item.content}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Main>
    );
};

export default Settings;
